export default __webpack_public_path__ + "68120dc35ac46d62348bc80ba42a77dc.png";